import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { getActivePortal, getActivePortalLoaded, LoadActivePortal } from '../store';

import { routes as landingPageRoutes } from '../../landing-pages/landing-pages.routes';
import { routes as homeRoutes } from '../portals.routes';
import { getRouterState, SetTheme } from 'src/app/store';
import { CookieConfigService } from '@teamfoster/sdk/cookie-ngrx';

export const ActivePortalGuard: CanActivateFn = route => {
  const store = inject(Store);
  const router = inject(Router);

  const state = store.selectSignal(getRouterState);
  const cookieConfig = inject(CookieConfigService);

  return store
    .select(getActivePortalLoaded)
    .pipe(
      withLatestFrom(store.select(getActivePortal)),
      tap(([loaded, portal]) => {
        if (!loaded) {
          const name = route.params['portalName'] || route.data['portalName'];
          store.dispatch(LoadActivePortal({ name }));
        } else {
          cookieConfig.analyticsCode = portal?.analyticsTrackingCode;
          if (portal?.id === 1) {
            cookieConfig.useTagManager = true;
          }
        }
      }),
      filter(([loaded]) => loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
